import React from "react";
import "./InviteTypeSelectorModal.css";

const InviteTypeSelectorModal = ({
  visible,
  onClose,
  onSelect,
}) => {
  if (!visible) return null;
const handleButtonClick = (e, role) => {
  e.stopPropagation();
  e.preventDefault();
  onSelect(role);
  onClose();
};


  return (
    <div className="its-overlay">
      <div className="its-box">
        <h3 className="its-title">Choose Invite Type</h3>

        <p className="its-sub">How would you like to share the invitation?</p>

        <div className="its-buttons">
          <button
            className="its-btn guest"
              onClick={(e) => handleButtonClick(e, "guest")}

            // onClick={() => {
            //   onSelect("guest");
            //   onClose();
            // }}
          >
            Send Guest Invite
          </button>

          <button
            className="its-btn usher"
              onClick={(e) => handleButtonClick(e, "usher")}

            // onClick={() => {
            //   onSelect("usher");
            //   onClose();
            // }}
          >
            Send Usher Invite
          </button>
        </div>

        <button className="its-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default InviteTypeSelectorModal;
